// extracted by mini-css-extract-plugin
export default {"btn__wrapper":"RequestDetails_btn__wrapper__Xi54u"};